import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleInput from "../../../../modules/SimpleInput";
import Button from "../../../../modules/commons/Button";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import { searchOptions, tableColumns } from "../config";
import IndentUnitSudahProsesDetail from "./indentUnitSudahProsesDetail";
import IndentUnitSudahProsesFilter from "./indentUnitSudahProsesFilter";

class IndentUnitSudahProsesTable extends Component {
  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    ...tableColumns,
    {
      name: "indentStatus",
      label: "Status",
    },
    {
      name: "indentNo",
      label: "Aksi",
      options: {
        customBodyRender: (val) => (
          <SimpleButton
            category="action_button"
            icon={<i className="fa fa-lg fa-eye" />}
            onClick={() => this.handleDetailVisibility(val)}
          />
        ),
      },
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      detailId: "",
      filterVisible: false,
      filterData: {},
    };
  }

  handleFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleDetailVisibility = (id) => {
    this.setState((prevValue) => ({
      ...prevValue,
      detailId: id,
    }));
  };

  handleChangePage = (tableState) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleRefresh = () =>{
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {},
    }));
  }

  render() {
    return (
      <>
        <FlexView
          vAlignContent="center"
          hAlignContent="right"
          className="margin-top-15px margin-bottom-15px"
        >
          <FlexView
            vAlignContent="center"
            hAlignContent="right"
            style={{ gap: "10px", marginRight: "20px" }}
          >
            <SimpleDDL
              placeholder="Kd/Nm. Varian"
              box="search"
              containerclassname="margin-bottom-none width width-250px"
              isClearable
              options={searchOptions}
              value={this.props.state.searchData?.key || null}
              onChange={(value) =>
                this.props.onSetState((prevValue) => ({
                  ...prevValue,
                  searchData: {
                    key: typeof value == 'string'? value?.toUpperCase() : value,
                  },
                }))
              }
            />
            <SimpleInput
              placeholder="Text yang dicari"
              containerclassname="margin-bottom-none"
              readOnly={!this.props.state.searchData?.key}
              value={this.props.state.searchData?.value}
              onChange={({ target }) =>
                this.props.onSetState((prevValue) => ({
                  ...prevValue,
                  searchData: {
                    ...prevValue.searchData,
                    value: target.value.toUpperCase(),
                  },
                }))
              }
            />
            <SimpleButton
              className="margin-left-none"
              onClick={this.props.onSearch}
              // disabled={!this.props.state.searchData?.key}
            >
              Cari
            </SimpleButton>
          </FlexView>
          <Button
            type="button"
            className="btn background-red"
            onClick={this.handleFilterVisibility}
          >
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
          </Button>
        </FlexView>
        <SimpleDataTable
          data={this.props.state.dataTable}
          columns={this.tableColumns}
          toCount={this.props.state.pagination.totalData}
          page={this.props.state.pagination.page - 1}
          rowsPerPage={this.props.state.pagination.limit}
          options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
          footerAdditionalButtons={<SimpleButton secondary>Cetak</SimpleButton>}
        />
        {this.state.filterVisible && (
          <IndentUnitSudahProsesFilter
            state={this.props.state}
            visible={this.state.filterVisible}
            onSubmit={this.props.onSubmitFilter}
            onSetState={this.props.onSetState}
            onClickClose={this.handleFilterVisibility}
          />
        )}
        {this.state.detailId && (
          <IndentUnitSudahProsesDetail
            id={this.state.detailId}
            kodeCabang={this.props.state.kodeCabang?.value}
            onRefresh={() => this.handleRefresh()}
            onClickClose={() => this.handleDetailVisibility()}
          />
        )}
      </>
    );
  }
}

export default IndentUnitSudahProsesTable;
